import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { ArrowRightIcon } from 'lucide-react';
import { CHECKOUT_URL } from '../data/content';
import { trackCheckout } from '../hooks/useMetaPixel';
type FloatingCTAProps = {
  triggerId: string;
};
export function FloatingCTA({
  triggerId
}: FloatingCTAProps) {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const trigger = document.getElementById(triggerId);
    if (!trigger) return;
    const onScroll = () => {
      const rect = trigger.getBoundingClientRect();
      setVisible(rect.bottom < 0);
    };
    onScroll();
    window.addEventListener('scroll', onScroll, {
      passive: true
    });
    return () => window.removeEventListener('scroll', onScroll);
  }, [triggerId]);
  return <AnimatePresence data-id="element-32" data-mp="38ap7mwx4oadk">
      {visible ? <motion.div initial={{
      y: 90,
      opacity: 0
    }} animate={{
      y: 0,
      opacity: 1
    }} exit={{
      y: 90,
      opacity: 0
    }} transition={{
      type: 'spring',
      stiffness: 320,
      damping: 30
    }} className="fixed inset-x-0 bottom-0 z-40 border-t border-white/10 bg-navy-deep/95 px-3 pb-[calc(0.65rem+env(safe-area-inset-bottom))] pt-2.5 backdrop-blur-md" data-id="element-33" data-mp="38cjre7wnxwg2">
          <div className="mx-auto flex max-w-xl flex-col items-center gap-1.5" data-id="element-34" data-mp="2pbcyrnd38d5g">
            <a href={CHECKOUT_URL} onClick={trackCheckout} className="animate-cta-shake flex w-full items-center justify-center gap-2 rounded-xl bg-gold px-4 py-3.5 text-[14px] font-extrabold uppercase tracking-wide text-navy-deep shadow-[0_8px_24px_-8px_rgba(200,162,74,0.85)] active:scale-[0.98] sm:text-base" data-id="element-35" data-mp="2uafw0lmttf2v">
              Get instant access — $27
              <ArrowRightIcon className="h-4 w-4" data-id="element-36" data-mp="2bdeoou5sv2vr" />
            </a>
            <p className="text-[11px] font-medium text-white/60" data-id="element-37" data-mp="4m6to3rvs9fp">
              One-time payment • Lifetime access • 7-day guarantee
            </p>
          </div>
        </motion.div> : null}
    </AnimatePresence>;
}